// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'
import { sagaScopeSchema } from './sagaMemory'

export const sagaSkillSchema = z.object({
  id: z.string().max(200),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),

  agentId: z.string().max(200),
  name: z.string().max(200),
  category: z.string().max(200),
  verificationType: z.enum(['verified', 'self-reported', 'endorsed']),

  verificationSource: z.string().max(500).optional(),
  verificationProof: z.string().max(1000).optional(),
  completionCount: z.number().int().min(0).default(0),
  confidence: z.number().min(0).max(1).default(0),
  firstVerified: z.string().max(200).datetime().optional(),
  lastVerified: z.string().max(200).datetime().optional(),

  endorsedByWallet: z.string().max(200).optional(),
  endorsedByHandle: z.string().max(64).optional(),
  endorsementSignature: z.string().max(500).optional(),

  scope: sagaScopeSchema,

  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
})

export type SagaSkillInput = z.infer<typeof sagaSkillSchema>
